import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-whatsapp.svg";
import * as styles from "./Icon.module.scss";

type WhatsappProps = React.SVGProps<SVGSVGElement>;

export const Whatsapp = ({ className, ...props }: WhatsappProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
